import { PHONE_REGEX } from 'utilities/helper/phoneValidation';
import * as Yup from 'yup';
export const LoginSchema = Yup.object().shape({
  phoneNumber: Yup.string()
    .required('شماره تلفن اجباری می باشد')
    .matches(PHONE_REGEX, 'شماره تلفن را به درستی وارد نمایید'),
});
